import React, { FC } from 'react'
import cn from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import type { Page } from '@commerce/types/page'
import getSlug from '@lib/get-slug'
import { Container } from '@components/ui'
import s from './Footer.module.css'
import { showHtml } from '@lib/utils/utils'
import { useTranslations } from 'next-intl'
import { FaInstagram } from 'react-icons/fa'
import Script from 'next/script'
import LegalGuaranteeNotice from '@components/legal/LegalGuaranteeNotice'
import Image from "next/legacy/image"
import WiderrufModal from '@components/common/WiderrufModal'

interface Props {
  className?: string
  children?: any
  settings?: any
  color?: string
}


const Footer: FC<Props> = ({ className, settings, color }) => {
  const t = useTranslations('Global')
  const klaviyoKey: any = process.env.NEXT_PUBLIC_KLAVIYO_KEY || null

  return (
    <>
      <footer style={color ? { backgroundColor: color + '!important' } : undefined} className={'bg-neutral400'}>
        <Container className={' px-0'}>
          <div
            className='grid grid-cols-1 lg:grid-cols-12 gap-8 py-space12 text-primary transition-colors duration-150 px-0'>
            <div className='col-span-12'>
              <Link href='/' className='flex flex-initial items-center font-bold md:mr-24 w-e107'>
                <span className={'icon-Logo-Remi text-neutral900 block text-heading02'}></span>
              </Link>
              {/* Right-of-withdrawal ("Widerruf") request — opens a modal
                  asking for order number + email; /api/widerruf forwards it
                  to customer support. */}
              <div className='mt-6'>
                <WiderrufModal />
              </div>
              {/*<div id='trustbadgeCustomContainer' className={s.trustbadgeCustomContainer}>*/}
              {/*</div>*/}
              {/*<script async*/}
              {/*        data-desktop-y-offset='0'*/}
              {/*        data-mobile-y-offset='0'*/}
              {/*        data-desktop-disable-reviews='true'*/}
              {/*        data-desktop-enable-custom='true'*/}
              {/*        data-desktop-position='right'*/}
              {/*        data-desktop-custom-width='120'*/}
              {/*        data-desktop-enable-fadeout='false'*/}
              {/*        data-disable-mobile='true'*/}
              {/*        data-disable-trustbadge='false'*/}
              {/*        data-mobile-custom-width='120'*/}
              {/*        data-mobile-disable-reviews='true'*/}
              {/*        data-mobile-enable-custom='true'*/}
              {/*        data-mobile-position='right'*/}
              {/*        data-mobile-enable-topbar='false'*/}
              {/*        data-mobile-enable-fadeout='true'*/}
              {/*        data-color-scheme='light'*/}
              {/*        src='//widgets.trustedshops.com/js/XB69B2B795DB8E4A1F6991EF3810DCBE2.js'>*/}
              {/*</script>*/}
            </div>
          </div>
          <div
            className='grid grid-cols-2 lg:grid-cols-4 gap-8 text-primary transition-colors duration-150 px-0'>
            <div className='col-span-1 lg:col-span-1'>
              <h4 className={'mb-2 md:mb-6 text-neutral900 text-paragraph02 font-medium'}><span
                className={'font-medium'}>{t('myAccount')}</span></h4>
              {settings?.footerNavigation?.footerTop?.FooterFour.items?.map((navEl: any) => (
                (navEl?.link?.internalLink || navEl?.link?.externalUrl) && (
                  <div key={navEl?._key} className='py-2 md:py-0 md:pb-4 text-neutral800 text-paragraph03'>
                    <Link
                      href={navEl?.link?.internalLink || navEl?.link?.externalUrl || '#'}
                      target={navEl?.link?.externalUrl ? '_blank' : undefined}
                      rel='noreferrer'
                      className='text-neutral900 hover:text-neutral800 transition ease-in-out duration-150'
                    >
                      {navEl.text}
                    </Link>
                  </div>
                )
              ))}
            </div>
            <div className='col-span-1 lg:col-span-1'>
              <h4 className={'mb-2 md:mb-6 text-neutral900 text-paragraph02 font-medium'}><span
                className={'font-medium'}>{t('support')}</span></h4>
              {settings?.footerNavigation?.footerTop?.FooterTwo.items?.map((navEl: any) => (
                (navEl?.link?.internalLink || navEl?.link?.externalUrl) && (
                  <div key={navEl?._key} className='py-2 md:py-0 md:pb-4 text-neutral800 text-paragraph03'>
                    <Link
                      href={navEl?.link?.internalLink || navEl?.link?.externalUrl || '#'}
                      target={navEl?.link?.externalUrl ? '_blank' : undefined}
                      rel='noreferrer'
                      className='text-neutral900 hover:text-neutral800 transition ease-in-out duration-150'
                    >
                      {navEl.text}
                    </Link>
                  </div>
                )
              ))}
            </div>
            <div className='col-span-1 lg:col-span-1'>
              <h4 className={'mb-2 md:mb-6 text-neutral900 text-paragraph02'}><span
                className={'font-medium'}>{t('learn')}</span></h4>
              {settings?.footerNavigation?.footerTop?.FooterThree.items?.map((navEl: any) => (
                (navEl?.link?.internalLink || navEl?.link?.externalUrl) && (
                  <div key={navEl?._key} className='py-2 md:py-0 md:pb-4 text-neutral800 text-paragraph03'>
                    <Link
                      href={navEl?.link?.internalLink || navEl?.link?.externalUrl || '#'}
                      target={navEl?.link?.externalUrl ? '_blank' : undefined}
                      rel='noreferrer'
                      className='text-neutral900 hover:text-neutral800 transition ease-in-out duration-150'
                    >
                      {navEl.text}
                    </Link>
                  </div>
                )
              ))}
            </div>
            <div className='col-span-1 lg:col-span-1'>
              <h4 className={'mb-2 md:mb-6 text-neutral900 text-paragraph02 font-medium'}><span
                className={'font-medium'}>{t('remiHealth')}</span>
              </h4>
              {settings?.footerNavigation?.footerTop?.FooterOne.items?.map((navEl: any) => (
                (navEl?.link?.internalLink || navEl?.link?.externalUrl) && (
                  <div key={navEl?._key} className='py-2 md:py-0 md:pb-4  text-neutral800 text-paragraph03'>
                    <Link
                      href={navEl?.link?.internalLink || navEl?.link?.externalUrl || '#'}
                      target={navEl?.link?.externalUrl ? '_blank' : undefined}
                      rel='noreferrer'
                      className=' text-footergrey2 hover:text-neutral800 transition ease-in-out duration-150'
                    >
                      {navEl.text}
                    </Link>
                  </div>
                )
              ))}
              <div className='py-3 md:py-0 md:pb-4 text-neutral800 text-paragraph03'>
                <a rel='noreferrer' target='_blank' href='https://www.instagram.com/remi_health/' className=''>
              <span className={'inline-block text-left w-8 align-middle text-neutral800'}><FaInstagram
                size={24} /></span><span
                  className={'inline-block align-middle'}>Follow us</span>
                </a>
              </div>
            </div>
          </div>
          <div className={'mt-6'}>
            <a href={'https://learn.myremi.com/gruendung-innovativ-foerderung'} target={'_blank'} rel={'noreferrer'}>
              <Image
                src={'https://remihealth.b-cdn.net/images/H%20Kofinanziert%20von%20der%20Europa%CC%88ischen%20Union_POS.png'}
                width={200} height={42} alt={'EU'} />
            </a>
          </div>
          <div
            className='grid grid-cols-1 lg:grid-cols-4 gap:2 md:gap-8 text-neutral700 transition-colors duration-150 px-0 mt-6 pb-6'>
            <div className='col-span-1 lg:col-span-3'>
              <div className={s.footerBottomCopy + ''}>
            <span className={'text-paragraph03 text-neutral700'}
                  dangerouslySetInnerHTML={showHtml(settings?.settings?.copyright_content ?? '')} />
              </div>
            </div>
            <div className='col-span-1 lg:col-span-1'>
              <div className={s.footerBottomNav + ''}>
                {(() => {
                  const items: any[] = settings?.footerNavigation?.footerBottom[0]?.items ?? []
                  // EU legal-guarantee notice, reachable from every page (Commission
                  // guidelines' "header/footer" pattern). Not a CMS link: it opens the
                  // dialog. Placed after the AGB entry; appended when there is none.
                  const guarantee = (
                    <span key='legal-guarantee' className='text-paragraph03 text-neutral700 md:hover:text-neutral800'>
                      <LegalGuaranteeNotice variant='trigger' appearance='footer' />
                    </span>
                  )
                  const agbIndex = items.findIndex((navEl: any) => /\bAGB\b|terms/i.test(`${ navEl?.text ?? '' }`))
                  const rendered = items.map((navEl: any) => (
                    (navEl?.link?.internalLink || navEl?.link?.externalUrl) && (
                      <span key={navEl?._key}>
                      <Link
                        href={navEl?.link?.internalLink || navEl?.link?.externalUrl || '#'}
                        target={navEl?.link?.externalUrl ? '_blank' : undefined}
                        rel='noreferrer'
                        className='text-paragraph03 text-neutral700 md:hover:text-neutral800 transition ease-in-out duration-150'
                      >
                        <span className={'text-neutral700'}>{navEl.text}</span>
                      </Link>
                    </span>
                    )
                  ))
                  rendered.splice(agbIndex >= 0 ? agbIndex + 1 : rendered.length, 0, guarantee)
                  return rendered
                })()}
              </div>
            </div>
          </div>
        </Container>
        <Script
          defer
          type='text/plain'
          className='cmplazyload' data-cmp-vendor='c31589'
          data-cmp-src={'https://static.klaviyo.com/onsite/js/' + klaviyoKey + '/klaviyo.js'}
        />
      </footer>
    </>
  )
}

function usePages(pages?: Page[]) {
  const { locale } = useRouter()
  const sitePages: Page[] = []

  if (pages) {
    pages.forEach((page) => {
      const slug = page.url && getSlug(page.url)
      if (!slug) return
      if (locale && !slug.startsWith(`${locale}/`)) return
      sitePages.push(page)
    })
  }

  return {
    sitePages: sitePages.sort(bySortOrder)
  }
}

// Sort pages by the sort order assigned in the BC dashboard
function bySortOrder(a: Page, b: Page) {
  return (a.sort_order ?? 0) - (b.sort_order ?? 0)
}

export default Footer
